.zeroStateContainer {
  height: 56vh;
  width: 100%;
  background: var(--static-background-strong);
  border-radius: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
}

.zeroStateContentContainer {
  padding: 30px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  box-sizing: border-box;
}

.zeroStateHeaderText {
  margin-top: 40px;
  font-size: var(--fs-small-heading);
  color: var(--static-text-strong);
}

.zeroStateSubText {
  margin-top: 5px;
  font-size: var(--fs-small);
  color: var(--static-text-weak);
}

.zeroStateButtonContainer {
  margin-top: 30px;
}

.zeroStateButton {
  padding: 8px 16px !important;
}

.loaderContainer {
  width: 100%;
  background-color: var(--static-background-standard);
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1rem;
  height: 100%;
}